import {convertGRank, convertRank, maxGRank} from '@/lib/base/ranking.js';
import faceSmile from '@/assets/img/teacherManagement/face-smile.svg';
import faceNormal from '@/assets/img/teacherManagement/face-normal.svg';
import faceAngry from '@/assets/img/teacherManagement/face-angry.svg';

const mixinObject = {
  methods: {
    getConvertFunc(student) {
      return student?.isGRank === false ? convertRank : convertGRank;
    },

    getName(student) {
      return student?.realName || '';
    },

    getRankText(student) {
      const convertFunc = this.getConvertFunc(student);
      return convertFunc(student?.rank || 0);
    },
    getStudyTask(student) {
      return student?.studyTask || {};
    },
    getHasLastMission(student) {
      const {lastBatch} = this.getStudyTask(student);
      return lastBatch;
    },
    getLastMissionRank(student) {
      if (this.getHasLastMission(student)) {
        const {currentBatch, lastBatch} = this.getStudyTask(student);
        if (currentBatch > lastBatch) {
          return student.rank;
        } else {
          return student.rank - 1;
        }
      }
      return null;
    },
    getLastMissionText(student) {
      if (this.getHasLastMission(student)) {
        const convertFunc = this.getConvertFunc(student);
        const rank = this.getLastMissionRank(student);
        const {lastBatch} = this.getStudyTask(student);
        return `${convertFunc(rank)}-${lastBatch}`;
      }
      return this.$t('暫無資料');
    },

    getHasNewestMission(student) {
      return student?.rank < maxGRank;
    },
    getNewestMissionRank(student) {
      return student?.rank;
    },
    getNewestMissionText(student) {
      if (this.getHasNewestMission(student)) {
        const {currentBatch} = this.getStudyTask(student);
        const rank = this.getNewestMissionRank(student);
        const convertFunc = this.getConvertFunc(student);
        return currentBatch ? `${convertFunc(rank)}-${currentBatch}` : convertFunc(rank);
      }
      return this.$t('已完成所有任務');
    },
    getNewestMissionTime(student) {
      if (this.getHasNewestMission(student)) {
        return this.$day().format('YYYY/MM/DD');
      }
      return null;
    },

    getDiligenceScore(student) {
      return student?.diligenceScore || 0;
    },
    getHasDiligenceScore(student) {
      return (
        this.getDiligenceScore(student) > 9 ||
        this.$day().diff(student.createdAt, 'days') > 3
      );
    },
    getDiligenceScoreFace(student) {
      if (this.getHasDiligenceScore(student)) {
        const diligenceScore = this.getDiligenceScore(student);
        if (diligenceScore >= 20) {
          return faceSmile;
        } else if (diligenceScore >= 10) {
          return faceNormal;
        } else {
          return faceAngry;
        }
      }
      return null;
    },
    getDiligenceScoreText(student) {
      switch (this.getDiligenceScoreFace(student)) {
        case faceSmile:
          return this.$t('優秀');
        case faceNormal:
          return this.$t('普通');
        case faceAngry:
          return this.$t('待加強');
        default:
          return this.$t('數據不足');
      }
    },

    getVerification(student) {
      return student?.verification;
    },
    getHasVerification(student) {
      return this.getVerification(student);
    },
    getVerificationFace(student) {
      if (this.getHasVerification(student)) {
        const verification = this.getVerification(student);
        return verification.isPass ? faceSmile : faceAngry;
      }
      return null;
    },
    getVerificationText(student) {
      if (this.getHasVerification(student)) {
        const {rank, isGRank, totalScore} = this.getVerification(student);
        const convertFunc = isGRank === false ? convertRank : convertGRank;
        return this.$t('{rank}-{score}分', {
          rank: convertFunc(rank),
          score: totalScore,
        });
      }
      return this.$t('數據不足');
    },

    getGameStatistic(student) {
      return student?.gameStatistic || {};
    },
    getHasgameStatistic(student) {
      const {win, lose} = this.getGameStatistic(student);
      return win + lose >= 10;
    },
    getGameStatisticFace(student) {
      const {win} = this.getGameStatistic(student);
      if (this.getHasgameStatistic(student)) {
        if (win >= 7) {
          return faceSmile;
        } else if (win >= 4) {
          return faceNormal;
        } else {
          return faceAngry;
        }
      }
      return null;
    },
    getGameStatisticText(student) {
      const {win, lose} = this.getGameStatistic(student);
      if (this.getHasgameStatistic(student)) {
        return this.$t('{win}勝{lose}敗', {win, lose});
      }
      return this.$t('數據不足');
    },
  },
};

export default mixinObject;
